import { getToken, removeStation } from '@/utils/auth.js'

export default function(){
	let redirectUrl = '/stationlist';
	if(getToken() == 'administratorhzinfov4'){
		redirectUrl = '/power/real/dashboard'
		removeStation();//超级管理员没有站点信息
	}
	return [
		{ 
			path: '/', 
			redirect: redirectUrl,
			hidden: true
		},
		// { 
		// 	title: '设备管理', 
		// 	children:[
				// {
				// 	title: '项目管理', path: '/power/equipment/project/index'
				// },
				// {
				// 	title: '设备类型', path: '/power/equipment/types/index'
				// },
				// {
				// 	title: '设备配置', path: '/power/equipment/organization/index'
				// },
				// {
				// 	title: '意见反馈', path: '/power/equipment/feedback/index'
				// }
		// 	]
		// },
//		{title: '设备授权', path: '/power/system/equipmentGiveDuty'},
//		{title: '站点通讯权限', path: '/power/system/stateCommunicttionGiveDuty'},
//		 {
//		 	title: '人员轨迹',
//		 	path: '/power/power_distribution/track'
//		 },
//		 {
//		 	title: '移动端权限管理',
//		 	path: '/system/mobile/auth'
//		 }, 
	]
}


// WEBPACK FOOTER //
// ./src/router/config.js